import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    formName: '',
};

export const formsSlice = createSlice({
    name: "events",
    initialState,
    reducers: {
        setFormName: (state, { payload }) => {
            state.formName = payload;
            return state;
        }
    },
});

export const { setFormName } = formsSlice.actions;

export default formsSlice.reducer;
